export default [
  {
    title: 'Benvinguda',
    element: 'body',
    text: 'Benvingut a Idonia, la seva plataforma mèdica d\'intercanvi d\'imatges. En aquesta visita l\'ajudarem a començar.',
    placement: {
      relativeTo: 'viewport',
      position: 'bottom right'
    }
  },
  {
    title: 'El Meu Espai',
    element: '.file-container',
    text: 'A "El Meu Espai" trobarà totes les seves carpetes, documents i estudis emmagatzemats a Idonia. Arrossegui aquí la carpeta o els arxius que vulgui carregar.',
    placement: {
      relativeTo: 'viewport',
      position: 'center center'
    }
  },
  {
    title: 'Botó "Nou"',
    element: 'button.new',
    text: 'Utilitzi aquest menú per crear una carpeta, o carregui un fitxer o una carpeta des del seu dispositiu. També pot carregar un estudi DICOM complet per visualitzar-lo.',
    placement: {
      relativeTo: 'element',
      position: 'left top'
    }
  },
  {
    title: 'Fitxers compartits',
    element: 'a[data-name="shared"]',
    text: 'A "Compartit amb mi" podrà veure els casos que la SERAM ha compartit amb vostè, així com altres arxius i carpetes compartits per altres usuaris.',
    placement: {
      relativeTo: 'element',
      position: 'right bottom'
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/common/tour/tours/desktop/ca-ES/seram2018.js